import { DefaultError, useMutation } from "@tanstack/react-query";
import { PageModuleDataToInsert } from "entities/pages/types";
import { bulkCreateModulesByBrandSetting } from "../api/bulkCreateModulesByBrandSetting";
import { bulkUpdateModulesByBrandSetting } from "../api/bulkUpdateModulesByBrandSetting";
import { getModuleListByBranchSettingQueryData } from "../queries/useModuleListByBrandSettingQuery";

type Params = {
  brandId: string;
  settingId: string;
  batchData: PageModuleDataToInsert[];
  onSuccess?: () => void;
};

export const useCreateModuleBatchMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      const prevData = getModuleListByBranchSettingQueryData(
        params.brandId,
        params.settingId,
      );

      // we assume that modules batch will be created at the top of the list
      //  with correct orders, so we are just incrementing it

      const batchDataToUpdate =
        prevData?.reduce((acc, moduleData) => {
          return {
            ...acc,
            [moduleData.id]: {
              order: moduleData.order + params.batchData.length,
            },
          };
        }, {}) ?? {};

      const shouldBulkUpdate = !!Object.keys(batchDataToUpdate).length;

      await Promise.all([
        bulkCreateModulesByBrandSetting(
          params.brandId,
          params.settingId,
          params.batchData,
        ),
        shouldBulkUpdate &&
          bulkUpdateModulesByBrandSetting(
            params.brandId,
            params.settingId,
            batchDataToUpdate,
          ),
      ]);
    },
    onSuccess: (_, params) => {
      params.onSuccess?.();
    },
    onError: (e) => {
      console.error("Error occurred when creating batch of modules", e);
    },
  });
};
